export { type BadgeProps, Badge } from "#badge";
